export interface CreateKBDocumentResponse {
  success: boolean;
  hashExists?: boolean;
  nameExists?: boolean;
  error?: string;
}

export interface CreateKBDocumentInput {
  contentRefId?: string;
  orgId: string;
  kbGroupName?: string;
  title?: string;
  description?: string;
}

export const KB_DOCUMENT_MAX_FILE_SIZE = 20971520;

export const MAX_FILES_PER_UPLOAD = 600;
